module.exports = __webpack_public_path__ + "img/avg-fuel-economy.7dbbd434.svg";